import { AbstractControl } from '@angular/forms';

export const getTrackBy = (index: number): number => index;

// Below update in header style is due to css issue in idp header component which adds redundant element to the dom.
//  This should be removed once this is fixed from their end
export const updateHeaderStyle = (active: boolean) => {
  const headerElement = document.getElementsByClassName(
    'nav-header-background-color'
  )[0] as HTMLElement;

  if (headerElement && window.innerWidth >= 992) {
    active
      ? headerElement.setAttribute('style', 'display: none !important')
      : headerElement.setAttribute('style', 'display: block !important');
  }
};

/**
 * Extracts the last number in the option field string
 * @example
 * ```typescript
 * getBusinessSize("1");        // 1
 * getBusinessSize("2 - 49");   // 49
 * getBusinessSize("1000+");    // 1000
 * ```
 */
export const getBusinessSize = (option: string | undefined): number | null => {
  if (!option) return null;
  const match = option.match(/\d+(?=\D*$)/);
  return match ? parseInt(match[0], 10) : null;
};

/**
 * Maps the contract type code string to the specific string the enrollment api needs. Maps CSA/MSA to CRP
 * @param contractType code from Eligibility
 * @returns The mapped contract type code (OTH, SKY, or CRP).
 */
export function getEnrollmentContractType(contractType: string | null): string {
  if (!contractType) {
    return 'OTH';
  }

  switch (contractType.toUpperCase()) {
    case 'OTH':
      return 'OTH';
    case 'SKY':
      return 'SKY';
    default:
      return 'CRP';
  }
}

/**
 * Validates if there is no whitespace in the value of the given control
 * @returns null if there is no whitespace
 */
export const noWhitespaceValidator = (control: AbstractControl) => {
  return /^\s|\s$/.test(control.value || '') ? { whitespace: true } : null;
};
